/** @format */

import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { getIsLoadingData, getProfile, getProfilePicture } from './store';
import { State } from 'src/app/store';
import { Profile } from './models/profile';
import { GetProfile, PruneManagedActiveUsers } from './store/application';
import { BrowserUtils } from '@azure/msal-browser';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
	profilePicture$: Observable<Blob | string | null>;
	profilePicture: Blob | string | null = null;

	profile$: Observable<Profile>;
	profile!: Profile;

	isLoadingData = true;
	isLoadingData$: Observable<boolean>;

	isIframe = false;
	hasPrunedData = false;

	private ngUnsubscribe: Subject<void> = new Subject();

	constructor(private store$: Store<State>) {
		this.profilePicture$ = this.store$.select(getProfilePicture);
		this.profile$ = this.store$.select(getProfile);
		this.isLoadingData$ = this.store$.select(getIsLoadingData);
		this.isIframe = BrowserUtils.isInIframe();
	}

	ngOnInit(): void {
		this.isLoadingData$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((isLoadingData) => (this.isLoadingData = isLoadingData));
		this.profilePicture$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((profilePicture) => (this.profilePicture = profilePicture));

		this.profile$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((profile) => {
			this.profile = profile;
			if (this.profile.manage.length > 0 && !this.hasPrunedData) {
				this.hasPrunedData = true;
				let users = this.profile.manage.map((managed) => managed.user);
				this.store$.dispatch(PruneManagedActiveUsers({ users }));
			}
		});

		this.store$.dispatch(GetProfile({ skipUserActivation: true }));
		// this.store$.dispatch(GetProfile({ skipUserActivation: false }));
	}
}
